"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var client_lib_js_player_addons_common_player_1 = require("@sky-uk-ott/client-lib-js-player-addons-common-player");
var winrt_bridge_1 = require("./winrt-bridge");
var messenger_service_1 = require("./messenger-service");
var uwp_player_1 = require("./uwp-player");
var uwp_storage_1 = require("./uwp-storage");
var uwp_info_1 = require("./uwp-info");
var uwp_input_1 = require("./uwp-input");
var uwp_lifecycle_1 = require("./uwp-lifecycle");
var uwp_capabilities_1 = require("./uwp-capabilities");
var uwp_media_remote_service_1 = require("./uwp-media-remote-service");
var UWPDeviceFactory = (function () {
    function UWPDeviceFactory(appName, context) {
        if (context === void 0) { context = window; }
        this.appName = appName;
        this.context = context;
    }
    UWPDeviceFactory.prototype.identifiers = function () {
        return [client_lib_js_player_addons_common_player_1.DeviceType.XboxOne];
    };
    UWPDeviceFactory.prototype.getInstance = function () {
        return this.device;
    };
    UWPDeviceFactory.prototype.initialise = function () {
        var _this = this;
        var messenger = messenger_service_1.MessengerService.getInstance(this.context);
        var bridge = winrt_bridge_1.WinRtBridge.getInstance(this.context);
        var mediaRemote = uwp_media_remote_service_1.UWPMediaRemoteService.getInstance(bridge);
        var player = new uwp_player_1.UWPPlayer(this.context, messenger, mediaRemote);
        var storage = new uwp_storage_1.UWPStorage(this.context, bridge, this.appName);
        var input = new uwp_input_1.UWPInput(this.context, messenger, mediaRemote);
        var deviceInfo = new uwp_info_1.UWPInfo(bridge);
        var lifecycle = new uwp_lifecycle_1.UWPLifecycle(bridge, messenger);
        var capabilities = new uwp_capabilities_1.UWPCapabilities();
        return Promise.all([deviceInfo.initialise(), player.initialise()])
            .then(function () {
            _this.device = {
                player: player,
                storage: storage,
                capabilities: capabilities,
                input: input,
                deviceInfo: deviceInfo,
                lifecycle: lifecycle,
            };
        })
            .then(function () {
            messenger.sendMessage({
                command: 'loadComplete',
            });
        });
    };
    return UWPDeviceFactory;
}());
exports.UWPDeviceFactory = UWPDeviceFactory;
